export default __webpack_public_path__ + "static/3-9c818c475610cd21d6d1afd67683c8ee.jpg";